import { UserFormService } from '../shared/services/user-form.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { UserDefaults } from '../shared/model/user.model';
import { Subscription } from 'rxjs';
import { Context, ContextSelectorService } from 'ngx-global-nav';
import { UserSubmitService } from '../shared/services/user-submit.service';
import { UserService } from '../shared/services/user.service';
import { UserFormComponent } from '../user-form/user-form.component';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss', '../shared/shared.styles.scss'],
})
export class CreateComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  appPrefix = 'usr';
  selectedId = {};
  isSubmitting = false;
  activateOnSubmit = false;
  readonly mode = 'create';
  orgId = '';

  createdForm = false;

  userForm: FormGroup;

  @ViewChild(UserFormComponent) userFormComponent: UserFormComponent;

  constructor(
    private route: ActivatedRoute,
    private userFormService: UserFormService,
    private contextSelectorService: ContextSelectorService,
    public userSubmitService: UserSubmitService,
    private userService: UserService,
  ) {
    this.selectedId = this.route?.snapshot?.params?.selectedId;
    const orgSub = this.contextSelectorService.currentContext$.subscribe((orgs: Context[]) => {
      this.orgId = orgs[0].id;
      if (this.userForm && this.userForm.controls['organization_id']) {
        this.userForm.patchValue({ organization_id: this.orgId });
      }
    });
    this.userService.resetUser();
    this.subscriptions.push(orgSub);
  }

  ngOnInit() {
    this.userForm = this.userFormService.createUserForm({ ...UserDefaults, organization_id: this.orgId }, false);
    this.userFormService.disableFields(this.userForm, false);
    this.userFormService.disableSyncToEcrm(this.userForm, { ...UserDefaults });
    this.createdForm = true;
  }

  handleCancel() {
    this.userFormComponent.handleExit(this.selectedId as string);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
